<app-card>
  <div cardBody class="d-flex justify-content-center align-items-center flex-column py-10">
    <span class="svg-icon svg-icon-empty mb-10" inlineSVG="{{icon}}"></span>
    <p class="fs-5 mb-0 text-description text-gray-400">{{text}}</p>
    <ng-content></ng-content>
  </div>
</app-card>
